import axios from "axios";
import dayjs from "dayjs";

const defaultApiUrl = "https://tmi-uploaderfunctions.azurewebsites.net";
const defaultApiKey = "/4l/DO9rCA/BoqZ31NLsoIgzztDs17giZTvwbz2/IhPeM/9BJftXKA==";

const apiUrl = process.env.VUE_APP_API_URL ?? defaultApiUrl;
const apiKey = process.env.VUE_APP_API_KEY ?? defaultApiKey;

const imageManagementEndpoint = `${apiUrl}/api/ImageMgmt?code=${apiKey}&clientId=default`;

let config = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const defaultImageData = {
  StockNumber: "",
  ImageFile: null,
  UploadPath: "",
  ImageExtension: null,
  Status: "",
  DateDeletedOn: dayjs(),
  DateArchivedOn: dayjs(),
  DateUpdatedOn: dayjs(),
  DateCreatedOn: dayjs(),
  IsDeleted: false,
  IsArchived: false,
  IsNew: false,
  IsUpdated: false,
  TotalSize: 0,
  Height: 0,
  Width: 0,
  SortOrder: 0,
  PrevSortOrder: 0,
  BlobImageUrl: "",
  ModifiedBy: "",
  UserEmail: ""
};

export function addNewImage(image, profile) {
    var allImages = [];

  if(Array.isArray(image)) {
      image.forEach(element => {

          let flatimage = flattenImage(element);

          allImages.push(flatimage);
    });
  } else {
    let flatimage = flattenImage(image);
    allImages.push(flatimage)
    }
  let uploadImage = {
        'ModifiedBy': profile.name,
        'UserEmail': profile.email,
        EquipmentImageInfo: allImages
  };
    if (image.length === 0) {
        return Promise.reject("Image array is empty:addNewImage");
    }
    return axiosPostAddUpdate(uploadImage);
}

export function updateExistingImage(images, profile) {
  var allImages = [];

  images.forEach(element => {
    let flatimage = flattenImage(element)
    allImages.push(flatimage)
  });

  let updateImage = {
        'ModifiedBy': profile.name,
        'UserEmail': profile.email,
        EquipmentImageInfo: allImages
    };
    if (images.length === 0) {
        return Promise.reject("Image array is empty:updateExistingImage");
    } 

    return axiosPostRequest(images, updateImage);
}

export function restoreImage(image, profile) {
  var allImages = [];
  let flatImage = flattenImage(image); 
  allImages.push(flatImage);

  let updateImage = {
        'ModifiedBy': profile.name,
        'UserEmail': profile.email,
        EquipmentImageInfo: allImages
    };
    if (!image || !image.id) {
        return Promise.reject("Id is Missing:restoreImage");
    }
   
    return axiosPostRequest(image, updateImage);
}

export function updateExistingCroppedImage(image, profile) {
  var allImages = [];
  let flatimage = flattenImage(image)
  allImages.push(flatimage)

  let updateImage = {
    'ModifiedBy': profile.name,
    'UserEmail': profile.email,
    EquipmentImageInfo: allImages
    };
    if (!image || !image.id) {
        return Promise.reject("Id is Missing:updateExistingCroppedImage");
    }
    return axiosPostRequest(image, updateImage);
    
}
export function axiosPostAddUpdate(imageData) {
    return axios
        .post(`${imageManagementEndpoint}`, imageData, { config } )
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });

}
export function axiosPostRequest(image, imageData) {

    return axios.post(`${imageManagementEndpoint}&id=${image.id}`, imageData )
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });

}
export function deleteExistingImage(image, profile) {
    this.loading = true;
  var allImages = [];
  if (Array.isArray(image)) {
    image.forEach(element => {
      flattenImage(element)
      allImages.push(element)
    });
  } else {
    if (!image || !image.id) {
        return Promise.reject("Id is Missing:deleteExistingImage");
    }
    flattenImage(image);
    allImages.push(image)
  }
  let deleteImage = {
      'ModifiedBy': profile.name,
      'UserEmail': profile.email,
    EquipmentImageInfo: allImages
    };
    
    return axiosPostRequest(image, deleteImage);
}

export default {
  defaultImageData,
  addNewImage,
  restoreImage,
  updateExistingImage,
  updateExistingCroppedImage,
  deleteExistingImage,
};

const flattenImage = (image) => {
  var imageDuplicate = JSON.parse(JSON.stringify(image));
  imageDuplicate.id = image.id;
  imageDuplicate.StockNumber = image.StockNumber;
  imageDuplicate.ImageFile = image.ImageFile;
  imageDuplicate.UploadPath = image.UploadPath;
  imageDuplicate.ImageExtension = image.ImageExtension;
  imageDuplicate.Status = image.Status;
  imageDuplicate.DateDeletedOn = image.DateDeletedOn;
  imageDuplicate.DateArchivedOn = image.DateArchivedOn;
  imageDuplicate.DateUpdatedOn = image.DateUpdatedOn;
  imageDuplicate.DateCreatedOn = image.DateCreatedOn;
  imageDuplicate.IsDeleted = image.IsDeleted;
  imageDuplicate.IsArchived = image.IsArchived;
  imageDuplicate.IsNew = image.IsNew;
  imageDuplicate.IsUpdated = image.IsUpdated;
  imageDuplicate.SortOrder = JSON.stringify(image.SortOrder);
  imageDuplicate.PrevSortOrder = JSON.stringify(image.PrevSortOrder);
  imageDuplicate.BlobImageUrl = image.BlobImageUrl;
  imageDuplicate.ModifiedBy = image.ModifiedBy;
  imageDuplicate.UserEmail = image.UserEmail;
  imageDuplicate.Name = image.name;

  return imageDuplicate;
};
